import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { partnerProfileApi } from "../../apis";
import ProfileSection from "../../Components/ProfileSection";
import CoursesSection from "../../Components/CoursesSection";
import PageTitle from "../../Components/UI/PageTitle";
import Loader from "../../Components/Loader";
import ErrorAnimationComponent from "../../assets/lottie/ErrorAnimation/ErrorAnimationComponent";
import { transformKeys } from "../../_helper";
import ActivationHistory from "../../Components/ActivationHistory";
import ProfileSectionWithHistoryButton from "../../Components/TransactionsSection";
import RenewSubscriptionHistory from "../../Components/RenewSubscriptionHistory";

const Profile = () => {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    partnerProfileApi(id)
      .then((response) => {
        setProfileData(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        setError(error.message || "An error occurred while fetching data");
        setLoading(false);
      });
  }, [id]);

  if (loading) return <Loader />;
  if (error) return <ErrorAnimationComponent message={error} />;

  if (!profileData) return <div>No profile data available</div>;
  const { image, ...filteredProfileData } = profileData.personal_data;

  return (
    <>
      <PageTitle
        title="Partner Details"
        BreadcrumbItems={[
          { title: "home", link: "/" },
          { title: "Partners", link: "/partners-list" },
          { title: "Partner Details", link: "/" },
        ]}
      />
      <div className="tw-flex tw-flex-col tw-gap-4">
        <ProfileSection
          title="Personal Data"
          data={filteredProfileData ?? {}}
          img={image}
        />
        <ProfileSection
          title="Account Data"
          data={profileData?.account_data ?? {}}
        />
        <ProfileSection
          title="Package Data"
          data={profileData?.package_data?.[0] ?? {}}
          columns={2}
        />
        <CoursesSection courses={profileData?.courses_data ?? []} />
        <ProfileSectionWithHistoryButton
          link={`/PartnerTransactionsHistory/${id}`}
          title="E-Money Transactions"
          data={transformKeys(profileData?.eMoneyTransactions ?? {})}
        />
        <ProfileSection
          title="Wallet Data"
          data={profileData?.wallet_data ?? {}}
        />
        <ProfileSectionWithHistoryButton
          link={`/partner-settlement-history/${id}`}
          title="Settlements Data"
          data={profileData?.settlements_data ?? {}}
        />
        <ActivationHistory />
        <RenewSubscriptionHistory
          data={profileData?.subscriptions_data || []}
          title={"Renew Subscription History"}
        />
      </div>
    </>
  );
};

export default Profile;
